export default "__VITE_ASSET__BDI4Jfe3__"